/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.facilities.assign.controllers', [])

.controller('ResourcesFacilitiesAssignController', ['$scope', function($scope) {

    $scope.resourcesFacilitiesAssign = "Your spankin new application.resources.facilities.assign view!";

}]);